import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import { ContentNotificationTypesGrid } from '@/modules/configurationModule/detail/notifications/components/notification-types-grid/notification-types-grid.models'
import {
    initialNotificationTypesModalState,
    NotificationTypesModalActiveTab,
    NotificationTypesModalState
} from '@/modules/configurationModule/detail/notifications/components/notification-types-modal/notification-types-modal.models'
import BasicDataForm
    from '@/modules/configurationModule/detail/notifications/components/notification-types-modal-basic-data-form/basic-data-form.vue'
import { CommonLanguageResponse } from '@/api/services/common/language/common-language.dto'
import languageService from '@/api/resources/common/languageService'
import TextTranslations
    from '@/modules/configurationModule/detail/notifications/components/notification-types-modal-text-translations/text-translations.vue'
import { cloneDeep } from 'lodash'
import {
    NotificationTypesModalBasicData,
    NotificationTypesModalBasicDataForm
} from '@/modules/configurationModule/detail/notifications/components/notification-types-modal-basic-data-form/basic-data-form.model'
import { TranslationResponse } from '@/api/services/common.dto'

@Component({
    components: { BasicDataForm, TextTranslations }
})
export default class NotificationTypesModal extends Vue {
    @Ref() readonly notificationTypesModal!: any
    @Prop(String) readonly actionTitle!: string
    @Prop(Boolean) readonly isGlobal!: boolean
    @Provide() externalValidator = this.$validator
    @Emit()
    update(notificationTypes: NotificationTypesModalState): NotificationTypesModalState {
        return {
            id: this.state.id,
            ...notificationTypes
        }
    }
    @Emit()
    create(notificationTypes: NotificationTypesModalState): NotificationTypesModalState {
        return notificationTypes
    }
    private state: NotificationTypesModalState
    private languages!: CommonLanguageResponse[]

    constructor() {
        super()
        this.state = initialNotificationTypesModalState()
        this.languages = []
    }

    async show(selectedRow: ContentNotificationTypesGrid): Promise<void> {
        await this.getAllActiveAndUiEnabled()
        await this.initializeNotification(selectedRow)
        this.notificationTypesModal.show()
    }
    updateBasicData(basicDataForm: NotificationTypesModalBasicDataForm): void {
        this.state.basicData = cloneDeep(basicDataForm.basicData)
        const basicData = {
            ...this.state,
            ...basicDataForm,
            id: this.state.id
        }
        this.update(basicData)
    }
    createBasicData(basicDataForm: NotificationTypesModalBasicData): void {
        const basicData = {
            ...this.state,
            basicData: basicDataForm
        }
        this.create(basicData)
    }

    updateTranslations(): void {
        const translation = {
            ...this.state,
            id: this.state.id
        }
        this.update(translation)
    }

    async initializeNotification(notificationType: ContentNotificationTypesGrid): Promise<void> {
        this.state = initialNotificationTypesModalState()
        await this.$validator.reset()
        if (notificationType) {
            this.state = {
                id: notificationType.id,
                activeTabIndex: NotificationTypesModalActiveTab.BASIC_DATA,
                basicData: {
                    notificationType: notificationType.notificationType,
                    inboxChannelActive: notificationType.inboxChannelActive,
                    emailChannelActive: notificationType.emailChannelActive,
                    smsChannelActive: notificationType.smsChannelActive
                },
                subjectTranslations: this.setTranslationsLanguages(notificationType.subjectTranslations, this.languages),
                plainBodyTranslations: this.setTranslationsLanguages(notificationType.plainBodyTranslations, this.languages),
                htmlBodyTranslations: this.setTranslationsLanguages(notificationType.htmlBodyTranslations, this.languages)
            }
        }
    }
    setTranslationsLanguages(translations: Partial<TranslationResponse>[], languages: CommonLanguageResponse[]): Partial<TranslationResponse>[] {
        let translationsMap = cloneDeep(translations)
        languages.forEach(language => {
            const translationsHasLanguage = translationsMap?.find(subjectTranslation => subjectTranslation.language?.id === language.id)
            if (!translationsHasLanguage) {
                translationsMap?.push({
                    value: '',
                    language: language
                })
            }
        })
        return translationsMap
    }
    async getAllActiveAndUiEnabled(): Promise<void> {
        const [err, response] = await this.$_toCall(languageService.findAllActiveAndUiEnabled())
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            this.languages = []
        } else {
            this.languages = response
        }
    }

    hide(): void {
        this.notificationTypesModal.hide()
    }
}
